export default "__VITE_ASSET__BJvV1TYv__"